import CustomCard from "../../../components/card";
import { Button, IconButton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import net from "../../../data/network.json";
import {
  wrapperCex,
  wrapperHeader,
  wrapperItem,
  wrapperMain,
  wrapperMiddle,
  wrapperTopPart,
} from "./SwapConfirmation.style";
import useAppSelector from "../../../hooks/useSelector";
import EastIcon from "@mui/icons-material/East";
import { Link } from "react-router-dom";
import { FC, useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { createExchangeService, IRes } from "../../../services/createExchange";
import SwapDetails from "../swapDetails";
import { exchangeInfoService } from "../../../services/exchangeInfo";
import useAppDispatch from "../../../hooks/useDispatch";
import { setHistoryData } from "../../../redux/slices/historySlice";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { setToast } from "../../../redux/slices/toastSlice";
import { store } from "../../../redux/store";
import partner from "../../../data/partner.json";
import Timer from "../../../components/timer";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { baseImageUrl } from "../../../config/imageUrl";
import { AxiosError } from "axios";

interface IProps {
  setConfirm: (arg0: boolean) => void;
  setShowWallet: (arg0: boolean) => void;
  swapDetail: boolean;
  setSwapDetail: (swapDetail: boolean) => void;
  historyRequestId: string;
  setHistoryRequestId: (historyRequestId: string) => void;
  setSwitch: (arg0: number) => void;
  setLoading: (arg0: boolean) => void;
  timer: any;
  loading: boolean;
  setActive: (arg0: number) => void;
}

const SwapConfirmation: FC<IProps> = ({
  setConfirm,
  setShowWallet,
  swapDetail,
  setSwapDetail,
  historyRequestId,
  setHistoryRequestId,
  setSwitch,
  setLoading,
  timer,
  loading,
  setActive,
}) => {
  const [loading1, setLoading1] = useState(false);
  const [detailData, setDetailData] = useState<IRes>();
  const [exchangeInfo, setExchangeInfo] = useState<any>();
  const { coinData } = useAppSelector((state) => state.coinSelect);
  const { netIconFrom } = useAppSelector((state) => state.netIcon);
  const { netIconTo } = useAppSelector((state) => state.netIcon);
  const [intervalExchangeInfo, setIntervalExchangeInfo] = useState<any>();
  const dispatch = useAppDispatch();

  const toWalletAddressData = useAppSelector(
    (state) => state.walletAddress.toWalletAddress
  );
  const fromWalletAddressData = useAppSelector(
    (state) => state.walletAddress.fromWalletAddress
  );

  const fromExtraData = useAppSelector((state) => state.extraId.extraIdFrom);

  const toExtraData = useAppSelector((state) => state.extraId.extraIdTo);

  const selectedExchangeData = useAppSelector(
    (state) => state.selectedExchange
  );
  const fromValueData = useAppSelector(
    (state) => state.coinFromValue.fromValue
  );

  const exchangeResData = useAppSelector((state) => state.exchangeRes);

  useEffect(() => {
    if (
      localStorage.getItem("token_id") === null ||
      localStorage.getItem("token_id") === ""
    ) {
      var chars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      var newtokenid = "";
      for (var i = 0; i < 150; i++)
        newtokenid += chars[Math.floor(Math.random() * chars.length)];
      window.localStorage.setItem("token_id", newtokenid);
    }
  }, []);

  const createExchangeQuery = useMutation({
    mutationFn: createExchangeService,
  });

  const exchangeInfoQuery = useMutation({
    mutationFn: exchangeInfoService,
  });

  const fetchExchangeInfo = (exchangeID: any) => {
    exchangeInfoQuery.mutate(exchangeID, {
      onSuccess(data) {
        setExchangeInfo(data?.data);
      },
      onError(error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 403) {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        store.dispatch(
          setToast({
            open: true,
            type: "error",
            text: error?.message,
          })
        );
      },
    });
  };

  const handleConfirm = () => {
    console.log(exchangeResData.exchangeRes);
    setLoading1(true);
    setHistoryRequestId("");
    let token = localStorage.getItem("token_id");
    createExchangeQuery.mutate(
      {
        rate_id: exchangeResData?.exchangeRes?.rate_id,
        partner_name: selectedExchangeData?.selectedExchange?.partner_name,
        symbol_from: coinData[0].symbol,
        network_from: netIconFrom
          ? net.filter(
              (item) => `${baseImageUrl}/${item.image}` === netIconFrom
            )?.[0]?.name
          : net.filter(
              (item) =>
                item?.name.toUpperCase() === coinData[0]?.network.toUpperCase()
            )?.[0]?.name,
        symbol_to: coinData[1].symbol,
        network_to: netIconTo
          ? net.filter(
              (item) => `${baseImageUrl}/${item.image}` === netIconTo
            )?.[0]?.name
          : net.filter(
              (item) =>
                item?.name.toUpperCase() === coinData[1]?.network.toUpperCase()
            )?.[0]?.name,
        amount: fromValueData,
        fixed:
          selectedExchangeData?.selectedExchange?.exchange_type === "fixed"
            ? true
            : false,
        token_id: token,
        to_address: toWalletAddressData,
        extera_id: toExtraData ? toExtraData : undefined,
        refund_address: fromWalletAddressData
          ? fromWalletAddressData
          : undefined,
        refund_extera_id: fromExtraData ? fromExtraData : undefined,
      },
      {
        onSuccess(data) {
          if (data?.data?.Status === "OK") {
            setSwapDetail(true);
            setLoading1(false);
            setDetailData(data.data);
            store.dispatch(
              setToast({
                open: true,
                type: "success",
                text: "The transaction is created successfully!",
              })
            );
            data.data.exchangeID &&
              dispatch(setHistoryData(data.data.exchangeID));
            fetchExchangeInfo(data.data.exchangeID);
          } else if (data?.data?.Status === "Error") {
            store.dispatch(
              setToast({
                open: true,
                type: "error",
                text: data?.data?.Message,
              })
            );
          }
        },
        onError(error) {
          const axiosError = error as AxiosError;
          if (axiosError.response?.status === 403) {
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          store.dispatch(
            setToast({
              open: true,
              type: "error",
              text: error?.message,
            })
          );
        },
      }
    );
  };

  useEffect(() => {
    let newInterval: any;
    if (swapDetail) {
      newInterval = setInterval(() => {
        const exchangeID = detailData?.exchangeID;
        if (exchangeID) {
          fetchExchangeInfo(exchangeID);
        }
      }, 30000);

      setIntervalExchangeInfo(newInterval);
      return () => clearInterval(newInterval);
    } else {
      clearInterval(intervalExchangeInfo);
    }
  }, [swapDetail, detailData]);

  const handlecancel = () => {
    setConfirm(false);
    setShowWallet(false);
  };

  const handleBack = () => {
    setConfirm(false);
  };

  return (
    <>
      {!swapDetail ? (
        <Grid
          sx={wrapperMain}
          className="animate__animated animate__fadeIn fix_layout"
        >
          <CustomCard>
            <Grid sx={wrapperHeader} mt={2} mb={3} container>
              <IconButton onClick={handleBack}>
                <ArrowBackIosIcon />
              </IconButton>
              <Typography variant="h5" mt={0.6}>
                Swap Confirmation
              </Typography>
              <Grid container mt={0.3}>
                <IconButton
                  sx={{
                    color: (theme) => theme?.palette?.error?.main,
                    background: "transparent",
                    right: "-33px",
                  }}
                  onClick={handlecancel}
                >
                  <CloseIcon />
                </IconButton>
                <Grid container>
                  <Timer timer={timer} loading={loading} />
                  <IconButton className={loading ? "loading" : ""}>
                    <img
                      src="./assets/images/routes/refresh.svg"
                      alt="flashift"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={wrapperMiddle} container mt={1} mb={1}>
              <Typography variant="h6">Destination Address :</Typography>
              <Typography className="long_text">
                {toWalletAddressData}
              </Typography>
            </Grid>
            {toExtraData && (
              <Grid sx={wrapperMiddle} container mt={1} mb={1}>
                <Typography variant="h6">Destination Extra ID:</Typography>
                <Typography className="long_text">{toExtraData}</Typography>
              </Grid>
            )}
            {fromWalletAddressData && (
              <Grid sx={wrapperMiddle} container my={2}>
                <Typography variant="h6"> Refund Address :</Typography>
                <Typography className="long_text">
                  {fromWalletAddressData}
                </Typography>
              </Grid>
            )}
            {fromExtraData && (
              <Grid sx={wrapperMiddle} container mt={1} mb={1}>
                <Typography variant="h6">Refund Extra ID:</Typography>
                <Typography className="long_text">{fromExtraData}</Typography>
              </Grid>
            )}
            <Grid
              sx={{
                ...wrapperTopPart,
                background: (theme) => theme?.palette?.secondary?.light,
                borderRadius: "8px",
              }}
              p={2}
              container
            >
              <Grid sx={wrapperItem}>
                <Typography pl={6}>From</Typography>
                <Grid container style={{ position: "relative" }}>
                  <img
                    src={
                      coinData[0]?.image
                        ? coinData[0].image.startsWith("http")
                          ? coinData[0].image
                          : `${baseImageUrl}/${coinData[0].image}`
                        : "./assets/images/coins/noPic.svg"
                    }
                    alt="flashift"
                    width="40px"
                    height="40px"
                  />
                  <img
                    alt="flashift"
                    src={
                      netIconFrom
                        ? netIconFrom
                        : `${baseImageUrl}/${
                            net.filter(
                              (item) =>
                                item?.name.toUpperCase() ===
                                coinData[0]?.network.toUpperCase()
                            )?.[0]?.image
                          }`
                    }
                    width="15.5px"
                    height="15.5px"
                    className="netIcon"
                    style={{ left: "30px" }}
                  />
                  <Typography variant="h6" pl={1} mt={0.5}>
                    {coinData[0]?.symbol.toUpperCase()}
                    <Typography>
                      {net
                        .filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            coinData[0]?.network.toUpperCase()
                        )?.[0]
                        ?.name.toUpperCase()}
                    </Typography>
                  </Typography>
                </Grid>
                <Grid
                  container
                  style={{ justifyContent: "space-between" }}
                  pl={0.7}
                >
                  <Typography variant="h5">{fromValueData}</Typography>
                </Grid>
              </Grid>
              <Grid sx={wrapperItem}>
                <Typography pl={9.5}>To</Typography>
                <Grid container style={{ position: "relative" }}>
                  <Grid mr={1} mt={2}>
                    <EastIcon />
                  </Grid>
                  <img
                    src={
                      coinData[1]?.image
                        ? coinData[1].image.startsWith("http")
                          ? coinData[1].image
                          : `${baseImageUrl}/${coinData[1].image}`
                        : "./assets/images/coins/noPic.svg"
                    }
                    alt="flashift"
                    width="40px"
                    height="40px"
                  />
                  <img
                    alt="flashift"
                    src={
                      netIconTo
                        ? netIconTo
                        : `${baseImageUrl}/${
                            net.filter(
                              (item) =>
                                item?.name.toUpperCase() ===
                                coinData[1]?.network.toUpperCase()
                            )?.[0]?.image
                          }`
                    }
                    width="15.5px"
                    height="15.5px"
                    className="netIcon"
                    style={{ left: "50px" }}
                  />
                  <Typography variant="h6" pl={1} mt={0.5}>
                    {coinData[1]?.symbol.toUpperCase()}
                    <Typography>
                      {net
                        .filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            coinData[1]?.network.toUpperCase()
                        )?.[0]
                        ?.name.toUpperCase()}
                    </Typography>
                  </Typography>
                </Grid>

                <Grid
                  container
                  style={{ justifyContent: "space-between" }}
                  pl={4.7}
                >
                  <Typography variant="h5">
                    {selectedExchangeData?.selectedExchange?.amount.toFixed(5)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              sx={{
                ...wrapperCex,
                background: (theme) => theme?.palette?.secondary?.light,
                borderRadius: "8px",
                marginTop: "20px",
              }}
            >
              <Grid>
                <Typography>
                  <span>
                    {selectedExchangeData?.selectedExchange?.partner_name ? (
                      <img
                        src={`${baseImageUrl}/${
                          partner.filter(
                            (src) =>
                              src?.name ===
                              selectedExchangeData?.selectedExchange
                                ?.partner_name
                          )?.[0]?.image_small
                        }`}
                        alt="flashift"
                        height="24px"
                      />
                    ) : (
                      <img
                        src={`${baseImageUrl}/${
                          partner.filter(
                            (src) =>
                              src?.name ===
                              exchangeResData?.exchangeRes?.data[0]
                                ?.partner_name
                          )?.[0]?.image_small
                        }`}
                        alt="flashift"
                        height="24px"
                      />
                    )}
                  </span>
                  <span> Swap Via</span>
                  <span>
                    {selectedExchangeData?.selectedExchange?.partner_name
                      ? selectedExchangeData?.selectedExchange?.partner_name
                      : exchangeResData?.exchangeRes?.data[0]?.partner_name}
                  </span>
                </Typography>
              </Grid>
              <Grid
                sx={{
                  color: (theme) => theme?.palette?.primary?.main,
                  fontWeight: "700",
                }}
                pl={1}
              >
                Cex -
                <img
                  style={{
                    width: "17px",
                    position: "relative",
                    top: "3px",
                  }}
                  src={
                    (selectedExchangeData?.selectedExchange?.exchange_type
                      ? selectedExchangeData?.selectedExchange?.exchange_type
                      : exchangeResData?.exchangeRes?.data[0]
                          ?.exchange_type) === "floating"
                      ? "/assets/images/routes/float.svg"
                      : "/assets/images/routes/fixed.png"
                  }
                />
                {selectedExchangeData?.selectedExchange?.exchange_type
                  ? selectedExchangeData?.selectedExchange?.exchange_type
                  : exchangeResData?.exchangeRes?.data[0]?.exchange_type}
              </Grid>
            </Grid>
            <Grid my={2}>
              <Typography variant="h6" my={1} style={{ fontSize: "14px" }}>
                <Grid
                  sx={{
                    "& a,& svg": {
                      color: (theme) => theme?.palette?.primary?.main,
                    },
                  }}
                  mx={1}
                  gap="1"
                  container
                >
                  <ErrorOutlineIcon
                    style={{ width: "17px", margin: "2px 4px 0 0" }}
                  />
                  <span style={{ marginRight: "2px" }}>
                    By confirming the swap, you agreed to our
                  </span>
                  <Link to="https://flashift.app/terms/"> terms of use.</Link>
                </Grid>
              </Typography>
              <Button
                sx={{ marginTop: "30px" }}
                variant="contained"
                fullWidth
                onClick={handleConfirm}
                disabled={loading1}
              >
                {loading1 && (
                  <img
                    className="loading"
                    src="/assets/images/loading.svg"
                    alt="flashift"
                  />
                )}
                Confirm Swap
              </Button>
            </Grid>
          </CustomCard>
        </Grid>
      ) : (
        <SwapDetails
          setSwapDetail={setSwapDetail}
          setConfirm={setConfirm}
          setShowWallet={setShowWallet}
          detailData={detailData}
          exchangeInfo={exchangeInfo}
          historyRequestId={historyRequestId}
          setSwitch={setSwitch}
          setLoading={setLoading}
          setActive={setActive}
        />
      )}
    </>
  );
};

export default SwapConfirmation;
